import React from 'react';
import { Box, Grid } from '@mui/material';
import ResourceUsageCards from './ResourceUsageCards';
import UsageChart from './UsageChart';
import PropTypes from 'prop-types';

const MonitoringTab = ({ currentUsage, cpuData  }) => {


  return (
    <Box sx={{ py: 3, width:"100%" }}>
      {/* Real-time Usage Cards */}
      <ResourceUsageCards currentUsage={currentUsage} />

      {/* Usage Charts */}
      {/* <Grid  spacing={3} mb={3} sx={{display:'flex', flexDirection:"row", width:'100%'}}>
        <Grid item xs={12} lg={6} sx={{width:"50%",mr:1}}>
          <UsageChart 
            title="CPU Usage Over Time"
            type="cpu"
            color="#1976d2"
            data={cpuData?.timeseries} // Pass the CPU data timeseries to the chart

          />
        </Grid>
        <Grid item xs={12} lg={6} sx={{width:"50%"}}>
          <UsageChart 
            title="Memory Usage Over Time"
            type="memory"
            color="#2e7d32"
          />
        </Grid>
      </Grid> */}

      {/* <Grid spacing={3} sx={{display:'flex', flexDirection:"row", width:'100%'}}>
        <Grid item xs={12} lg={6} sx={{width:"50%",mr:1}}>
          <UsageChart 
            title="Network I/O"
            type="network"
            color="#d32f2f"
          />
        </Grid>
        <Grid item xs={12} lg={6}  sx={{width:"50%"}}>
          <UsageChart 
            title="Disk I/O Performance"
            type="disk"
            color="#ed6c02"
          />
        </Grid>
      </Grid> */}
    </Box>
  );
};
MonitoringTab.propTypes = {
  currentUsage: PropTypes.shape({
    cpu: PropTypes.number.isRequired,
    memory: PropTypes.number.isRequired,
    network: PropTypes.number.isRequired,
  }).isRequired,
  cpuData: PropTypes.shape({
    timeseries: PropTypes.arrayOf(PropTypes.shape({
      timestamp: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    })).isRequired,
  }).isRequired,
};

export default MonitoringTab;
